import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputSharedModule } from '../input-shared.module';
import { InputFileComponent } from './input-file.component';


@NgModule({
  declarations: [
    InputFileComponent
  ],
  imports: [
    CommonModule,
    InputSharedModule
  ],
  exports: [
    InputFileComponent
  ]
})
export class InputFileModule {
}
